import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Plans.css';
import plansData from '../data/plans.json';

const Plans = () => {
  const [billingPeriod, setBillingPeriod] = useState('monthly'); // monthly, halfyearly, yearly

  const plans = plansData;

  const getPeriodLabel = () => {
    switch (billingPeriod) {
      case 'monthly':
        return 'Mo';
      case 'halfyearly':
        return 'Hy';
      case 'yearly':
        return 'Yr';
      default:
        return 'Mo';
    }
  };

  const getPeriodName = () => {
    switch (billingPeriod) {
      case 'monthly':
        return 'Monthly';
      case 'halfyearly':
        return 'Half Yearly';
      case 'yearly':
        return 'Yearly';
      default:
        return 'Monthly';
    }
  };

  return (
    <div className="plans-page">
      <section className="plans-hero section">
        <div className="container">
          <h1 className="page-title">Subscription Plans</h1>
          <p className="page-subtitle">
            Choose the perfect plan for your cable TV business. All plans exclusive GST.
          </p>
        </div>
      </section>

      <section className="plans-content section">
        <div className="container">
          {/* Billing Period Toggle */}
          <div className="billing-toggle">
            <button
              className={`toggle-btn ${billingPeriod === 'monthly' ? 'active' : ''}`}
              onClick={() => setBillingPeriod('monthly')}
            >
              Monthly
            </button>
            <button
              className={`toggle-btn ${billingPeriod === 'halfyearly' ? 'active' : ''}`}
              onClick={() => setBillingPeriod('halfyearly')}
            >
              Half Yearly
            </button>
            <button
              className={`toggle-btn ${billingPeriod === 'yearly' ? 'active' : ''}`}
              onClick={() => setBillingPeriod('yearly')}
            >
              Yearly
            </button>
          </div>

          {/* Plans Grid */}
          <div className="plans-grid">
            {plans.map((plan, index) => {
              const currentPlan = plan[billingPeriod];
              const isPopular = plan.name === 'CableBiz Popular';
              
              return (
                <div key={index} className={`plan-card ${isPopular ? 'popular' : ''}`}>
                  {isPopular && <div className="popular-badge">Most Popular</div>}
                  
                  <div className="plan-header">
                    <h3 className="plan-name">{plan.name}</h3>
                    <div className="plan-price">
                      <span className="currency">₹</span>
                      <span className="amount">{currentPlan.price}</span>
                      <span className="period">/{getPeriodLabel()}</span>
                    </div>
                  </div>

                

                  <ul className="plan-features">
                    {plan.features && plan.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="feature-item">
                        {feature.included ? (
                          <span className="feature-check">✓</span>
                        ) : (
                          <span className="feature-cross">✗</span>
                        )}
                        <span className={`feature-text ${!feature.included ? 'disabled' : ''}`}>
                          {feature.text}
                        </span>
                      </li>
                    ))}
                  </ul>

                  <Link 
                    to="https://admin.cablebiz.in" 
                    className="btn btn-primary btn-full plan-btn"
                    onClick={(e) => {
                      e.preventDefault();
                      // You can add payment integration here
                      alert(`You selected ${plan.name} - ${getPeriodName()} plan. Contact us to proceed with payment.`);
                    }}
                  >
                    Buy Now
                  </Link>
                </div>
              );
            })}
          </div>

          {/* Additional Info */}
          <div className="plans-info">
            <div className="info-card">
              <h3>Why Choose CableBiz?</h3>
              <ul>
                <li>✓ Complete billing and management solution</li>
                <li>✓ Real-time reports and analytics</li>
                <li>✓ Mobile apps for operators and customers</li>
                <li>✓ 24/7 technical support</li>
                <li>✓ Regular updates and new features</li>
              </ul>
            </div>
            <div className="info-card">
              <h3>Need Help Choosing?</h3>
              <p>Not sure which plan is right for you? Contact our sales team for personalized recommendations based on your business needs.</p>
              <Link to="https://admin.cablebiz.in" className="btn btn-outline">
                Contact Sales
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Plans;

